import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { Logo } from './Logo';

export const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();
  const info = t.contactInfo;

  const links = [
    { to: '/', label: t.nav.home },
    { to: '/sobre', label: t.nav.about },
    { to: '/servicos', label: t.nav.services },
    { to: '/cases', label: t.nav.portfolio },
    { to: '/contato', label: t.nav.contact },
  ];

  return (
    <footer
      data-testid="site-footer"
      className="px-6 lg:px-12 pt-24 pb-10"
      style={{
        background: 'var(--paper-2)',
        borderTop: '1px solid var(--rule)',
        color: 'var(--ink)',
      }}
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="grid md:grid-cols-12 gap-12 pb-16 border-b" style={{ borderColor: 'var(--rule)' }}>
          <div className="md:col-span-6">
            <Logo />
            <p className="mt-6 max-w-sm font-serif italic text-lg leading-snug" style={{ color: 'var(--ink-2)' }}>
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-5">{t.footer.nav}</p>
            <ul className="space-y-3">
              {links.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-[13px] opacity-70 hover:opacity-100 transition-opacity"
                    data-testid={`footer-nav-${l.to === '/' ? 'home' : l.to.slice(1)}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-5">{t.footer.contact}</p>
            <ul className="space-y-3 text-[13px]">
              <li>
                <a href={`mailto:${info.email}`} className="opacity-70 hover:opacity-100 transition-opacity" data-testid="footer-email">
                  {info.email}
                </a>
              </li>
              <li>
                <a href={`tel:${info.phone}`} className="opacity-70 hover:opacity-100 transition-opacity" data-testid="footer-phone">
                  {info.phone}
                </a>
              </li>
              <li>
                <a
                  href={`https://wa.me/${info.whatsapp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="opacity-70 hover:opacity-100 transition-opacity"
                  data-testid="footer-whatsapp"
                >
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 text-[11px] tracking-wide opacity-50">
          © {year} Lawork<span className="align-super text-[0.55rem]">®</span> · {t.footer.rights}
        </div>
      </div>
    </footer>
  );
};
